export default "__VITE_ASSET__c5c13cdb__$_?nuxt_component=async&nuxt_component_name=SvgoFloorplanSecondFloor__"